import { gql } from '@apollo/client';

const initiateBuyNFTMutation = gql `
  mutation initiateBuyNFT(
    $nftTokenId: UUID1!
    $buyerAddress: String!
    $orgId: UUID1!
    $country: String
    $postalCode: String
    $currencyId: UUID1
    $cryptoTax: CryptoTax
    $taxAddress: TaxAddressInput
  ) {
    initiateBuyNFT(
      nftTokenId: $nftTokenId
      buyerAddress: $buyerAddress
      orgId: $orgId
      country: $country
      postalCode: $postalCode
      currencyId: $currencyId
      cryptoTax: $cryptoTax
      taxAddress: $taxAddress
    ) {
      proofOfApproval
      Network {
        id
        name
        chainID
        wethAddress
      }
      order {
        id
        nftTokenId
        tokenId
        tokenContract
        quantity
        nftOwnerAddress
        fixedPrice
        price {
          unit
          value
          type
        }
        nftToken {
          id
          name
          deployed
          tokenMetadata {
            name
            description
            image
          }
          nftContractID
        }
      }
    }
  }
`;
const updateTransactionHashMutation = gql `
  mutation updateTransactionHash(
    $nftTokenId: UUID1!
    $orgId: UUID1!
    $transactionHash: String!
    $buyerAddress: String!
    $orderId: UUID1
  ) {
    updateTransactionHash(
      nftTokenId: $nftTokenId
      orgId: $orgId
      transactionHash: $transactionHash
      buyerAddress: $buyerAddress
      orderId: $orderId
    ) {
      success
      order {
        id
        nftTokenId
        fixedPrice
        price {
          value
          unit
          type
        }
      }
      newNFTID
    }
  }
`;
const generateSecondaryInvoiceQueries = gql `
  query (
    $invoiceID: UUID1!
    $orderID: UUID1!
    $activityName: ActivityName!
    $invoiceResType: InvoiceResType
  ) {
    generateSecondaryInvoice(
      invoiceID: $invoiceID
      orderID: $orderID
      activityName: $activityName
      invoiceResType: $invoiceResType
    )
  }
`;
const generatePrimaryInvoiceQueries = gql `
  query (
    $invoiceID: UUID1!
    $invoiceResType: InvoiceResType!
  ) {
    generatePrimaryInvoice(
      invoiceID: $invoiceID
      invoiceResType: $invoiceResType
    )
  }
`;
const getUserOrderActivityQueries = gql `
  query (
    $orgId: UUID1!
    $filter: OrderActivityFilters
    $limit: Int
    $offset: Int
  ) {
    getUserOrderActivity(
      orgId: $orgId
      filter: $filter
      limit: $limit
      offset: $offset
    ) {
      totalCount
      data {
        CreatedAt
        nftImageUrl
        ActivityName
        TokenName
        TokenID
        NFTTokenID
        ContractName
        ContractAddress
        Price {
          value
          unit
        }
        NetworkID
        TransactionHash
        FromUserName
        ToUserName
        FromUserAvatar
        ToUserAvatar
        FromWallet {
          id
          name
          address
        }
        ToWallet {
          id
          name
          address
        }
        InvoiceURL
        InvoiceID
        OrderID
        Status
        cryptoTax {
          cryptoTaxPrice
          cryptoTotalPrice
          USDUnitprice
          taxPercentage
        }
        order {
          platformFee
          creatorFee
        }
      }
    }
  }
`;

export { generatePrimaryInvoiceQueries, generateSecondaryInvoiceQueries, getUserOrderActivityQueries, initiateBuyNFTMutation, updateTransactionHashMutation };
